import { createFileRoute } from '@tanstack/react-router'
import { Technicians } from '@/features/technicians'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/technicians/')({
  beforeLoad: requireAdmin,
  component: Technicians,
})
